import React, { useEffect, useState, useContext } from "react";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from "../components/button";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Config from "../config";
import CustomerContext from "../stores/customerContext";
import CheckoutForm from "../components/checkoutForm";
import YesNoOptions from "../stores/yesnooptions";
import DonationFrequencies from "../stores/donationFrequencies";
import fetchCancelPaymentIntent from "../services/fetchCancelPaymentIntent";
import { formatCurrency } from "../utils/productHelpers";

const stripePromise = loadStripe(Config.stripe_publishable_key);

export default function PaymentInfo({type, displayName, Previous, Next}) {
    const {customer, updateContextValue} = useContext(CustomerContext)
    const {yes, no, yesNoOptions} = YesNoOptions();
    const {one_time, monthly, annually} = DonationFrequencies();
    const [processingFee, setProcessingFee] = useState(null);
    const [shippingFee, setShippingFee] = useState(null);
    const [total, setTotal] = useState(null);

    // The base donation level plus any selected add-ons, each priced from Stripe's real Price object
    const items = customer != null
        ? [customer.selectedProduct, ...(customer.selected_addons || [])].filter(Boolean)
        : [];
    const subtotal = items.reduce((sum, item) => sum + ((item.defaultPrice?.unitAmount || 0) / 100), 0);

    useEffect(() =>{
        if(customer != null){
            let totalFee = subtotal;
            totalFee += DetermineProcessingFee(customer, subtotal);
            totalFee += DetermineShippingFee(customer);
            setTotal(`\$${totalFee.toFixed(2)}`);
        }
    }, [customer, subtotal]);

    function DetermineProcessingFee(customer, subtotal){
        let fee = 0;
        if(customer.cover_processing_fee === true){
            fee = subtotal * .03;
            setProcessingFee(`\$${fee.toFixed(2)}`);
        }
        else{
            setProcessingFee("No processing fee.");
        }

        return fee;
    }

    function DetermineShippingFee(customer){
        let fee = 0;
        if(customer.wanted_perks === false){
            setShippingFee("No shipping needed. I do not want my perks.");
        }
        else if(customer.wanted_perks === true && customer.shipped_perks !== true){
            setShippingFee(`No Shipping Needed. I will pick up my ${displayName} perks.`);
        }
        else if(customer.wanted_perks === true && customer.shipped_perks === true && customer.frequency === one_time){
            setShippingFee("$5");
            fee = 5;
        }
        else if(customer.wanted_perks === true && customer.shipped_perks === true){
            setShippingFee("$5.15");
            fee = 5.15;
        }
        else if(customer.wanted_perks === false){
            setShippingFee("No Shipping Needed, I do not want my perks.");
        }
        return fee;
    }

    const currencyFormat = (num) => {
        return "$" + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    };

    function HandleBackCall(){
        fetchCancelPaymentIntent(customer.subscription.SubscriptionId);
        Previous();
    }

    function PaymentSuccessful(){
        Next();
    }

    return(
        <Box>
            <Grid container>
                <Grid item xs={12}>
                    <h2 className="font-bold text-xl my-6 pb-3 border-b border-black">
                        Payment Information
                    </h2>
                </Grid>
            </Grid>
            <Grid container spacing={4}>
                <Grid item xs={6}>
                    <div className="border-2 border-black rounded-lg p-6 my-6">
                        <h3 className="font-bold text-lg mb-4">Order Summary</h3>
                        {
                            items.map((item) =>
                                <div key={item.id} className="flex justify-between items-baseline gap-6 py-2 border-b border-gray-300">
                                    <span>{item.name}</span>
                                    <span className="font-semibold whitespace-nowrap">{formatCurrency(item.defaultPrice?.unitAmount)}</span>
                                </div>
                            )
                        }
                        <div className="flex justify-between gap-6 pt-3 pb-2">
                            <span>Subtotal</span>
                            <span className="whitespace-nowrap">${subtotal.toFixed(2)}</span>
                        </div>
                        <div className="flex justify-between gap-6 py-2">
                            <span>Processing Fee</span>
                            <span className="text-right">{ processingFee }</span>
                        </div>
                        <div className="flex justify-between gap-6 py-2 border-b border-gray-300">
                            <span>Shipping Fee</span>
                            <span className="text-right">{ shippingFee }</span>
                        </div>
                        <div className="flex justify-between gap-6 pt-4 text-lg font-bold">
                            <span>Total</span>
                            <span className="whitespace-nowrap">{ total }</span>
                        </div>
                    </div>
                </Grid>
                <Grid item xs={6}>
                    <Elements
                        stripe={stripePromise}
                        options={{clientSecret: customer.subscription.clientSecret}}>
                            <CheckoutForm displayName={displayName} PaymentSuccessful={PaymentSuccessful}></CheckoutForm>
                        </Elements>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={6}>
                    <Button text={"Back"} displayName={displayName} onClick={HandleBackCall} />
                </Grid>
                <Grid item xs={6}>
                </Grid>
            </Grid>
        </Box>
      );
}
      